import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState : {
  leadUuids: string[];
  bulkType: string;
} = {
  leadUuids: [],
  bulkType: 'single',
};

export const bulkUpdateLeadsSlice = createSlice({
  name: 'listDetail/bulkUpdateLeads',
  initialState,
  reducers: {
    resetBulkUpdateLeads: () => initialState,
    setBulkUpdateUuids: (state, action: PayloadAction<{
      leadUuids: string[];
      type: string;
    }>) => {
      const {
        leadUuids,
        type,
      } = action.payload;
      state.leadUuids = leadUuids;
      state.bulkType = type;
    },
  },
});

export const {
  resetBulkUpdateLeads,
  setBulkUpdateUuids,
} = bulkUpdateLeadsSlice.actions;

export default bulkUpdateLeadsSlice.reducer;
